import React, { useState } from "react";
import { limitText } from "../../Utility/Utility";
import TagManager from 'react-gtm-module'
import { Img } from "../../Components/UI/UI";

export const RelateOrganizationsItem = (props) => {
  const name = props.name != undefined ? props.name : "";
  const id = props.id != undefined ? props.id : "";
  const href = props.href != undefined ? props.href : "";
  const [isHover, setIsHover] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  let cancelCoverCss;

  if (isClicked) {
    cancelCoverCss = " ac-cover-hide";
  } else {
    cancelCoverCss = " ";
  }

  return (
    <div
      className={
        "ac-wrapper-relateorganizationsitem ac-wrapper-relateorganizationsitem-" +
        id
      }
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <Img desktopImg={"Resources/URL-link.svg"} imgCss={"ac-img-link"} />
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={"ac-promo-link" + cancelCoverCss}
        onClick={()=> TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'resources', 'click_cta':name, 'event_details':'Related Organizations',}})}
      >
        <span>{name}</span>
      </a>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Components/RelateOrganizations/RelateOrganizationsItem.js